import $ from 'jquery';

class Tooltip {
  constructor() {
    this.tooltip = $('.js-tooltip');

    if (!this.tooltip) {
      return;
    }

    this.tooltipToggle();
  }

  tooltipToggle() {
    this.tooltip.each((i, el) => {
      const tooltip = $(el);
      const icon = tooltip.find('.js-tooltip-icon');
      const position = tooltip.attr('data-tooltip-position') || 'bottom';

      const tooltipInfo = $(
        `<span class="c-tooltip-info is-${position}"></span>`,
      ).text(tooltip.data('tooltip'));

      let t;

      icon
        .on('mouseenter', () => {
          t = setTimeout(() => {
            // const iconTop = icon.position().top;
            // const iconLeft = icon.position().left;
            const iconHeight = icon.height();

            tooltipInfo.appendTo(tooltip).css({
              position: 'absolute',
              // top: iconTop - iconHeight - tooltipInfo.outerHeight() + 5,
              // left: iconLeft,
            });

            if (position === 'right') {
              tooltipInfo.css({
                left: '100%',
                bottom: 0,
              });
            } else {
              tooltipInfo.css({
                bottom: iconHeight + 10,
              });
            }
          }, 100);
        })
        .on('mouseleave', () => {
          clearTimeout(t);
          tooltipInfo.remove();
        });
    });
  }
}

export default new Tooltip();



// WEBPACK FOOTER //
// ./src/scripts/modules/tooltip.js